/*
 * Прогрев тяжёлых необязательных скриптов (reCAPTCHA, чанк модалок).
 *
 * Они не нужны, пока посетитель ничего не делает, и раньше грузились по первому же
 * касанию. Но разбор такого скрипта занимает главный поток на сотни миллисекунд, и
 * приходился он ровно на первые жесты — следующий тап (меню → пункт меню) ждал, пока
 * поток освободится. Поэтому старт теперь не в момент касания, а в первой паузе после
 * него: QUIET_MS без нажатий. Прокрутка паузу не сбрасывает — она главному потоку не мешает.
 */
const INPUT_EVENTS = ['pointerdown', 'touchstart', 'keydown'];
const START_EVENTS = [...INPUT_EVENTS, 'scroll', 'focusin'];
const QUIET_MS = 2000;
// Если посетитель нажимает без пауз, дольше этого всё равно не ждём.
const MAX_WAIT_MS = 10000;
const LISTENER = { passive: true };

const tasks = [];
let state = 'idle'; // idle → waiting → done
let quietTimer = null;

const run = () => {
  if (state === 'done') {
    return;
  }
  state = 'done';
  clearTimeout(quietTimer);
  INPUT_EVENTS.forEach((event) => window.removeEventListener(event, restartQuietTimer, LISTENER));
  tasks.splice(0).forEach((task) => task());
};

function restartQuietTimer() {
  clearTimeout(quietTimer);
  quietTimer = setTimeout(run, QUIET_MS);
}

const start = () => {
  if (state !== 'idle') {
    return;
  }
  state = 'waiting';
  START_EVENTS.forEach((event) => window.removeEventListener(event, start, LISTENER));
  INPUT_EVENTS.forEach((event) => window.addEventListener(event, restartQuietTimer, LISTENER));
  restartQuietTimer();
  setTimeout(run, MAX_WAIT_MS);
};

export const warmUp = (task) => {
  if (state === 'done') {
    task();
    return;
  }
  tasks.push(task);
  if (state === 'idle' && tasks.length === 1) {
    START_EVENTS.forEach((event) => window.addEventListener(event, start, LISTENER));
  }
};
